export default function TopLoader({ progress }) {
  return (
    <div className="fixed top-0 left-0 w-full z-[9999] hidden lg:block">
      <div
        className="h-[3px] bg-green-600 transition-all duration-300 ease-out"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
}
